/*eslint-disable*/
import React, { useState } from 'react'
import { Image } from 'semantic-ui-react'

function ImageActionButton(props) {

    // const updateTyre = props.agGridReact ? props.agGridProps.baseUrl.updateTyre : ''

    const productImage = props.data.image ? props.data.image : ''

    return (
        <>
            <Image src={productImage} size='tiny' />
        </>
    )
}

export default ImageActionButton
